import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const loadAgentScript = () => {
  const script = document.createElement("script");
  script.type = "module";

  const isProd = process.env.REACT_APP_CANVAS_ENV === "prod";
  script.src = isProd
    ? "https://app.canvas.stillfront.com/agent.js"
    : "https://app-test.canvas.stillfront.com/agent.js";

  script.onload = () => {
    console.log("agent.js loaded:", process.env.REACT_APP_CANVAS_ENV);
  };

  script.onerror = () => {
    console.error("Failed to load agent.js:", process.env.REACT_APP_CANVAS_ENV);
  };

  document.body.appendChild(script);
};

loadAgentScript();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
